import { format, parse, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { cpf, cnpj } from 'cpf-cnpj-validator';

/**
 * Formata uma data para o formato YYYY-MM-DD
 */
export function formatDateToISO(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'yyyy-MM-dd');
}

/**
 * Formata uma data para exibição em português
 */
export function formatDateToBR(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'dd/MM/yyyy', { locale: ptBR });
}

/**
 * Formata um horário para o formato HH:mm
 */
export function formatTime(time: Date | string): string {
  const timeObj = typeof time === 'string' ? parse(time, 'HH:mm', new Date()) : time;
  return format(timeObj, 'HH:mm');
}

/**
 * Valida se uma string está no formato YYYY-MM-DD
 */
export function isValidISODate(dateString: string): boolean {
  const dateObj = parse(dateString, 'yyyy-MM-dd', new Date());
  return isValid(dateObj);
}

/**
 * Valida se uma string está no formato HH:mm
 */
export function isValidTime(timeString: string): boolean {
  const timeObj = parse(timeString, 'HH:mm', new Date());
  return isValid(timeObj);
}

/**
 * Valida um CPF usando o algoritmo dos dígitos verificadores
 */
export function isValidCpf(value: string): boolean {
  return cpf.isValid(value);
}

/**
 * Valida um CNPJ usando o algoritmo dos dígitos verificadores
 */
export function isValidCnpj(value: string): boolean {
  return cnpj.isValid(value);
}

/**
 * Valida um CPF ou CNPJ
 */
export function isValidCpfOrCnpj(value: string): boolean {
  return cpf.isValid(value) || cnpj.isValid(value);
}

/**
 * Gera um UUID v4 simples
 */
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
